import ThreadsSearchDialogList from './ThreadsSearchDialogList'
import ThreadsSearchDialogPreview from './ThreadsSearchDialogPreview'
import styles from './ThreadsSectionAllThreadsDialog.module.scss'

export default function ThreadsSearchDialogBody({ model, threads, loading, open, onThreadMenuAction, onRenameThread }) {
  return (
    <div className={styles.columns}>
      <ThreadsSearchDialogList
        searchValue={model.searchValue}
        setSearchValue={model.setSearchValue}
        filter={model.filter}
        setFilter={model.setFilter}
        threads={model.filteredThreads}
        hasThreads={threads.length > 0 || loading}
        loading={loading}
        previewId={model.previewThread?.id}
        selectThread={model.selectThread}
        onThreadMenuAction={onThreadMenuAction}
        onRenameThread={onRenameThread}
      />
      <ThreadsSearchDialogPreview
        thread={model.previewThread}
        open={open}
        onOpen={model.openThread}
      />
    </div>
  )
}
